import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M293.522 536.342l388.455 388.323c13.39 13.412 35.106 13.412 48.518 0 13.392-13.368 13.392-35.083 0-48.474l-364.32-364.197 364.32-364.196c13.392-13.39 13.392-35.104 0-48.495-13.412-13.369-35.127-13.369-48.518 0L293.523 487.646c-6.732 6.72-10.083 15.54-10.056 24.348-.027 8.81 3.323 17.628 10.055 24.348z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol